import { render } from "./dialogChoose.vue?vue&type=template&id=d92c6f1a"
import script from "./dialogChoose.vue?vue&type=script&lang=js"
export * from "./dialogChoose.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__